import { LoginFormDTO } from "utils/helpers/models/auth/login";
import { postRequest } from "../../utils/helpers/common/http-methods";

export const Auth_APIS = {
  login: (body: LoginFormDTO) => postRequest("/login", body),
  uploadFile: (body: FormData) => postRequest("/file/upload", body),
};
